import cx from 'classnames';
import { Icon } from 'assets/icons';
import React, { useState } from 'react';
import styles from './header.module.css';
import { Checkbox } from 'app/shared/input/checkbox';

const DataTableHeader = ({
  actions,
  data,
  onChange,
  sort_callback,
  is_bulk_mode,
  show_action_column = false
}) => {
  const [sort_field, setSortField] = useState('');
  const [sort_direction, setSortDirection] = useState(false);

  const handleBulkSelect = () => {
    if (!actions) return;
    onChange();
  };

  const handleSorting = (field) => {
    if (sort_field === field) {
      setSortDirection(!sort_direction);
    } else {
      setSortField(field);
      setSortDirection(true);
    }

    sort_callback(field, sort_direction);
  };

  return (
    <tr>
      <th key="bulk-check">
        <span className={styles.checkboxWrapper}>
          <Checkbox checked={is_bulk_mode} onClick={handleBulkSelect} />
        </span>
      </th>

      {data.map((field, index) => (
        <th
          key={`header-${field.key}-${index}`}
          onClick={() => field.sortable && handleSorting(field.key)}
        >
          <div className={cx(styles.colHeader)}>
            <span>{field.title}</span>
            {sort_field === field.key && (
              <Icon name={!sort_direction ? 'arrow_up' : 'arrow_down'} height={16} width={16} />
            )}
          </div>
        </th>
      ))}

      {show_action_column && (
        <th key="bulk-action">
          <div className={cx(styles.colHeader)}>
            <span>Action</span>
          </div>
        </th>
      )}
    </tr>
  );
};

export default DataTableHeader;
